var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebooksvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M11.6756 1.0743V9.89874C11.6756 10.2021 11.4085 10.4457 11.0812 10.4457H8.333V6.60591H9.73358L9.94294 5.10896H8.33059V4.15234C8.33059 3.71831 8.46054 3.4238 9.13677 3.4238H9.99829V2.08408C9.84909 2.06636 9.33891 2.02429 8.7421 2.02429C7.50035 2.02429 6.64846 2.72183 6.64846 4.00397V5.10896H5.24306V6.60591H6.64846V10.4479H1.48893C1.16165 10.4479 0.894531 10.2021 0.894531 9.90095V1.0743C0.894531 0.773144 1.16165 0.527344 1.48893 0.527344H11.0788C11.4085 0.527344 11.6756 0.773144 11.6756 1.0743Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebooksvg);
export default __webpack_public_path__ + "static/media/facebooksvg.ff4b9f0de528e9156ddbf846a153874a.svg";
export { ForwardRef as ReactComponent };